export default () => window.VERSION || '<undefined>'
